import {Box, CircularProgress, IconButton, styled} from '@mui/material'
import {Send} from 'iconsax-reactjs'

const SendRoundedIconWrapper = styled(Send)({
  'body[dir=rtl] &': {
    transform: 'scale(-1, 1)'
  }
})

interface SendMessageButtonProps {
  sending: boolean
  disabled: boolean
  onClick: () => void
}

const SendMessageButton = ({
  sending,
  disabled,
  onClick
}: SendMessageButtonProps) => {
  return (
    <Box
      sx={(theme) => ({
        width: 'auto',
        height: 'auto',
        marginX: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: theme.palette.primary.dark
        }
      })}
    >
      <IconButton
        size="small"
        disabled={sending || disabled}
        onClick={onClick}
        sx={(theme) => ({
          width: 40,
          height: 40,
          padding: 0,
          color: theme.palette.common.white
        })}
      >
        {sending ? <CircularProgress size={24} /> : <SendRoundedIconWrapper />}
      </IconButton>
    </Box>
  )
}

export default SendMessageButton
